import React from "react";
import SkeletonLoader from "./SkeletonLoader";

const DataStateWrapper = ({
  isLoading,
  error,
  children,
  skeletonType = "list",
  skeletonCount = 3,
  onRetry,
}) => {
  if (isLoading) {
    return <SkeletonLoader type={skeletonType} count={skeletonCount} />;
  }

  if (error) {
    return (
      <div className="error-container">
        <div className="error-content">
          <i className="pi pi-exclamation-triangle error-icon"></i>
          <h3 className="error-title">Erreur de chargement</h3>
          <p className="error-message">{error}</p>
          {onRetry && (
            <button onClick={onRetry} className="retry-btn">
              <i className="pi pi-refresh"></i> Réessayer
            </button>
          )}
        </div>
        <style jsx>{`
          .error-container {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 40px 20px;
            background: #fff5f5;
            border-radius: 8px;
            margin: 20px 0;
            border: 1px dashed #ffcccc;
          }
          .error-content {
            text-align: center;
          }
          .error-icon {
            font-size: 3rem;
            color: #dc3545;
            margin-bottom: 15px;
          }
          .error-title {
            color: #dc3545;
            margin-bottom: 10px;
            font-size: 1.2rem;
          }
          .error-message {
            color: #666;
            margin-bottom: 20px;
          }
          .retry-btn {
            background: #dc3545;
            color: white;
            border: none;
            padding: 8px 16px;
            border-radius: 4px;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            gap: 8px;
            font-weight: 500;
            transition: background 0.2s;
          }
          .retry-btn:hover {
            background: #c82333;
          }
        `}</style>
      </div>
    );
  }

  return children;
};

export default DataStateWrapper;
